import '@src/styles/components/customCollapse.scss';
import {Collapse} from 'antd';
import {CustomImage} from './index';
import {useMediaQuery} from '@src/hooks/useMediaQuery';
import iconDown from '@src/assets/icons/icon-down.svg';
import iconUp from '@src/assets/icons/icon-up.svg';

const {Panel} = Collapse;

function getExpandIcon() {
    return ({isActive}) =>
        isActive ? (
            <CustomImage className='open-close' src={iconDown}/>
        ) : (
            <CustomImage className='open-close' src={iconUp}/>
        );
}

const CustomCollapse = ({children, cardTitle, cardTitleAlign, bodyCenter, className, extra, defaultCollapse}) => {
    const isMobil = useMediaQuery({query: '(max-width: 1179.98px)'});

    return (
        <Collapse
            defaultActiveKey={defaultCollapse ? ['1'] : null}
            className={`${className || ''} custom-collapse`}
            ghost
            expandIconPosition='right'
            expandIcon={getExpandIcon()}
        >
            <Panel
                header={
                    <div style={{textAlign: isMobil ? 'left' : cardTitleAlign || 'left'}}>{cardTitle}</div>
                }
                extra={extra}
                key='1'
            >
                <div className={bodyCenter ? 'd-flex justify-content-center' : ''}>{children}</div>
            </Panel>
        </Collapse>
    );
};

export default CustomCollapse;
